import React from 'react';
import {Navigate} from 'react-router';
import {useSelector} from 'react-redux';

function RouteForL2({children}) {
  const {userInfo} = useSelector (state => state.auth);
  const {role} = userInfo;
  return role?.categories?.includes("L2") ? children : <Navigate to="/" />;
}

export default RouteForL2;
